import React, { FunctionComponent } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import styles from '../../CommonStyles/CommonGraphStyles.module.css';
import { setClearFilter, updateStage } from '../../Redux/actions';
import { apiTaskDrillDown } from '../../Services/analytics';
import { changeDateForRoute } from '../../Services/contacts';
import { sortAnalytics } from '../../Values/utils';
import * as ReactBootStrap from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { themeColors } from "../../Components/theme";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useMediaQuery, useTheme } from '@mui/material';
import "../../theme-vars.css";

type props = {
  data: any;
  type: 'Pending' | 'Completed' | 'Overdue';
  heading: string;
  usersList: any;
  checked: boolean;
  teamsData: any;
  style?: any;
  contacts: any;
  organizationUsers: any;
  filter: 'MTD' | 'YTD' | 'PM' | 'All' | 'CUSTOM';
  history: any;
  teamLeadUsers: any;
  user: any;
  source: boolean;
  taskFilter: any;
  leadFilter: any;
  theme: any;
};

const TaskBarTable: FunctionComponent<props> = ({
  data,
  type,
  heading,
  usersList,
  checked,
  teamsData,
  style,
  contacts,
  organizationUsers,
  filter,
  history,
  teamLeadUsers,
  user,
  source,
  taskFilter,
  leadFilter,
  theme
}) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const [table, setTable] = useState<any>({});
  const [tableData, setTableData] = useState<any[]>([]);
  const [sortData, setSort] = useState<any[]>([]);
  const [sortTable, setSortTable] = useState<boolean>(false);
  const [allContacts, setAllContacts] = useState<any[] | undefined>(undefined);

  useEffect(() => {
    let contact: any[] = [];
    Object.keys(contacts.data).forEach((key) => {
      contact = [...contact, ...contacts.data[key]];
    });
    setAllContacts(contact);
  }, [contacts.data]);

  useEffect(() => {
    let temp: { [key: string]: {} } = {};
    Object.keys(data).forEach((key: any) => {
      temp[key] = {
        Meeting: data[key].totalTaskCount[type]['Meeting']
          ? data[key].totalTaskCount[type]['Meeting']
          : 0,
        'Call Back': data[key].totalTaskCount[type]['Call Back']
          ? data[key].totalTaskCount[type]['Call Back']
          : 0,
        'Site Visit': data[key].totalTaskCount[type]['Site Visit']
          ? data[key].totalTaskCount[type]['Site Visit']
          : 0,
      };
    });
    setTable(temp);
  }, [data]);

  useEffect(() => {
    const tempList: any[] = [];
    Object.keys(table).forEach((key) => {
      tempList.push({
        name: checked ? key : source ? key : usersList[key],
        uid: key,
        meeting: table[key]['Meeting'],
        siteVisit: table[key]['Site Visit'],
        callBack: table[key]['Call Back'],
        Total:
          table[key]['Meeting'] +
          table[key]['Site Visit'] +
          table[key]['Call Back'],
      });
    });
    let teamTempData: any[] = [];
    if (checked) {
      tempList.forEach((user) => {
        const team = teamsData[user.name];
        let existing = teamTempData.filter((item) => item.name === team);
        if (existing.length !== 0) {
          Object.keys(user).forEach((key) => {
            if (key !== 'name') {
              if (existing[0][key]) {
                existing[0][key] += user[key];
              } else {
                existing[0][key] = user[key];
              }
            }
          })
        } else {
          teamTempData.push({ ...user, name: team });
        }
      });
    }

    const finalData = checked ? teamTempData : source ? tempList : tempList;
    let gt: { [key: string]: any } = {};
    finalData.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key !== 'name') {
          if (gt[key]) {
            gt[key] += item[key];
          } else {
            gt[key] = item[key];
          }
        }
      });
    });
    finalData.sort(sortAnalytics);
    finalData.unshift({ name: 'Grand Total', ...gt });
    setTableData(finalData.filter((item) => item.name !== undefined));
  }, [table, checked, source]);

  const sortFunction = (item: any) => {
    setSortTable(true)
    const grandTotalObj = tableData.filter((i: any) => i.name === "Grand Total");
    let sortData: any;
    switch (item) {
      case item:
        sortData = tableData?.filter((i: any) => i.name !== "Grand Total")?.sort((a: any, b: any) => {
          const valueA = a[item] || 0;
          const valueB = b[item] || 0;
          return valueA - valueB;
        })
        break;
      default:
        break;
    }
    setSort([...grandTotalObj, ...sortData]);
  }

  const handleSortTableData = (item: any) => {
    setSortTable(false)
    const grandTotalObj = tableData.filter((i: any) => i.name === "Grand Total");
    let sortData: any;
    switch (item) {
      case item:
        sortData = tableData?.filter((i: any) => i.name !== "Grand Total")?.sort((a: any, b: any) => {
          const valueA = a[item] || 0;
          const valueB = b[item] || 0;
          return valueB - valueA;
        })
        break;
      default:
        break;
    }
    setSort([...grandTotalObj, ...sortData]);
  }
  useEffect(() => {
    setTableData(sortData);
  }, [sortData])

  // when a user clicks on the table data which is not zero, it opens up a drill down page, the api data for which is stored in the local storage and the necessary call is made from that page
  const getDrillDownData = async (key: string, item: any) => {
    var keyF: any;
    for (var i = 0; i < localStorage.length; i++) {
      keyF = localStorage.key(i);
      if (keyF !== 'columns' && key !== 'isLightMode' && key !== 'totalMonths' && key !== 'lastAlertTime') {
        localStorage.removeItem(key);
      }
    }
    dispatcher(setClearFilter(true));
    if (allContacts) {
      let mapReportingTo: { [key: string]: string } = {};
      if (organizationUsers) {
        organizationUsers.forEach((item: any) => {
          if (mapReportingTo[item.uid] === undefined) {
            mapReportingTo[item.uid] = item.reporting_to;
          }
        });
      }
      const drillDownData = await apiTaskDrillDown(
        filter,
        item.name === 'Grand Total' ? user.uid : item.uid,
        type,
        key,
        taskFilter,
        leadFilter,
        item.name === 'Grand Total' ? true : false,
        source
      );
      localStorage.setItem('taskDrilldownData', JSON.stringify(drillDownData));
      history.push('/taskDrilldownData');
    }
  };
  const tableTextStyles = { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  // Example usage for font sizes
  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeLarge = "var(--font-size-large)";
  const fontSizeMedium = "var(--font-size-medium)";
  const fontSizeSmall = "var(--font-size-small)";

  return (
    <>
      <div className={styles.detailsBox} style={{
        ...style,
        overflowX: "auto",
        padding: isMobile ? "0.5rem" : 0,
        minHeight: 300
      }}>
        <Table
          striped
          bordered
          hover
          style={{
            minWidth: 600,
            tableLayout: "auto",
            fontFamily: fontFamilyMain,
            fontSize: fontSizeSmall,
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  width: "auto",
                  textAlign: "center",
                  ...tableTextStyles,
                  whiteSpace: "nowrap",
                  fontFamily: fontFamilyMain,
                  fontSize: fontSizeSmall
                }}
              >
                S.No
              </th>
              <th scope="col">Associate</th>
              <th scope="col" style={{ textAlign: "center", display: "flex" }}>Total {sortTable ? <ExpandLessIcon style={{ cursor: "pointer" }} onClick={() => handleSortTableData("Total")} /> : <> <KeyboardArrowDownIcon style={{ cursor: "pointer" }} onClick={() => sortFunction("Total")} /></>}</th>
              <th scope="col" style={{ textAlign: "center" }}>Meeting {sortTable ? <ExpandLessIcon style={{ cursor: "pointer" }} onClick={() => handleSortTableData("meeting")} /> : <> <KeyboardArrowDownIcon style={{ cursor: "pointer" }} onClick={() => sortFunction("meeting")} /></>}</th>
              <th scope="col" style={{ textAlign: "center" }}>Call Back {sortTable ? <ExpandLessIcon style={{ cursor: "pointer" }} onClick={() => handleSortTableData("callBack")} /> : <> <KeyboardArrowDownIcon style={{ cursor: "pointer" }} onClick={() => sortFunction("callBack")} /></>}</th>
              <th scope="col" style={{ textAlign: "center" }}>Site Visit {sortTable ? <ExpandLessIcon style={{ cursor: "pointer" }} onClick={() => handleSortTableData("siteVisit")} /> : <> <KeyboardArrowDownIcon style={{ cursor: "pointer" }} onClick={() => sortFunction("siteVisit")} /></>}</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => (
              <>
                <tr key={index} style={{ backgroundColor: index === 0 ? "rgb(233, 236, 239)" : '', fontSize: fontSizeSmall, fontFamily: fontFamilyMain }}>
                  <th style={tableTextStyles}>{index > 0 ? <>{index}</> : null}</th>
                  <th
                    style={{
                      fontSize: fontSizeSmall,
                    }}
                  >
                    {item.name}
                  </th>
                  <th
                    style={{
                      fontSize: fontSizeSmall,
                      fontWeight: index === 0 ? "bold" : 'normal',
                      textAlign: 'center',
                    }}
                    onClick={() =>
                      item.Total !== 0 && getDrillDownData('Total', item)
                    }
                  >
                    {item.Total}
                  </th>
                  <th
                    style={{
                      fontSize: fontSizeSmall,
                      textAlign: 'center',
                      cursor: item.meeting !== 0 ? 'pointer' : 'not-allowed',
                    }}
                    onClick={() =>
                      item.meeting !== 0 && getDrillDownData('Meeting', item)
                    }
                  >
                    {item.meeting}
                  </th>
                  <th
                    style={{
                      fontSize: fontSizeSmall,
                      textAlign: 'center',
                      cursor: item.callBack !== 0 ? 'pointer' : 'not-allowed',
                    }}
                    onClick={() =>
                      item.callBack !== 0 && getDrillDownData('Call Back', item)
                    }
                  >
                    {item.callBack}
                  </th>
                  <th
                    style={{
                      fontSize: fontSizeSmall,
                      textAlign: 'center',
                      cursor: item.siteVisit !== 0 ? 'pointer' : 'not-allowed',
                    }}
                    onClick={() =>
                      item.siteVisit !== 0 &&
                      getDrillDownData('Site Visit', item)
                    }
                  >
                    {item.siteVisit}
                  </th>
                </tr>
              </>
            ))}
          </tbody>
        </Table>
      </div>

    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    user: state.user.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(TaskBarTable);
